@if (form) {
	<div class="char-data__group">
		<rl-form-table-row [labelText]="'Task Set Name'" [required]="true"
			[class.has-error]="form.controls.taskName.hasError('required') && form.controls.taskName.touched">
			<ng-template rlFormTableControl>
				<rl-text-input [formControl]="form.controls.taskName"
					[dataLabel]="'inputFieldTaskName'"></rl-text-input>
			</ng-template>
			@if (form.controls.taskName.hasError('required') && form.controls.taskName.touched) {
				<ng-template rlFormTableMessage>
					Task Set Name is required.
				</ng-template>
			}
		</rl-form-table-row>

		<rl-form-table-row [labelText]="'Description'">
			<ng-template rlFormTableControl>
				<rl-text-area [formControl]="form.controls.description" [styles]="{maxLength: 10000}"
					[dataLabel]="'textareaDescription'"></rl-text-area>
			</ng-template>
		</rl-form-table-row>

		<rl-form-table-row [labelText]="'Initiate from Workflow Action'" [required]="true"
			[class.has-error]="form.controls.initAction.hasError('required') && form.controls.initAction.touched">
			<ng-template rlFormTableControl>
				<rl-dropdown-single [(formControl)]="form.controls.initAction" [options]="initialActionsOptions"
					[showEmptyOption]="true" [dataLabel]="'selectDropdownInitialAction'">
				</rl-dropdown-single>
			</ng-template>
			@if(form.controls.initAction.hasError('required') && form.controls.initAction.touched) {
				<ng-template rlFormTableMessage>
					Initiate from Workflow Action is required.
				</ng-template>
			}
		</rl-form-table-row>

		<rl-form-table-row [labelText]="'Block the following Workflow Action(s) until complete'">
			<ng-template rlFormTableControl>
				<rl-dropdown-multiple [(formControl)]="form.controls.blockActions" [options]="blockActionsOptions"
					[showEmptyOption]="true" [dataLabel]="'selectDropdownBlockActions'">
				</rl-dropdown-multiple>
			</ng-template>
		</rl-form-table-row>
	</div>
}